<template>
    <v-dialog v-model="dialog" fullscreen class="pa-0 ma-0" @keydown.esc="cancel">
        <v-card class="pa-0 ma-0">
            <v-toolbar color="#2B3848" dark>
                <v-icon class="mr-4">mdi-map</v-icon>
                <v-toolbar-title>Mapa de puntos de recogida</v-toolbar-title>

                <v-text-field
                    dark
                    flat
                    solo-inverted
                    hide-details
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    label="Buscar un  hotel o dirección postal"
                    v-model="searchText"
                    @keydown.enter.prevent="searchAddress(searchText)"
                    autocomplete="new"
                    class="ml-8 mr-8"
                />

                <v-btn dark color="red" @click="cancel">Cerrar</v-btn>
            </v-toolbar>

            <v-container fluid class="pa-0 ma-0">
                <v-row no-gutters>
                    <v-col cols="3">
                        <perfect-scrollbar>
                            <div class="pa-4" v-if="searching">
                                <v-progress-linear indeterminate color="primary" />
                            </div>
                            <div class="pa-4" v-else>
                                <template v-if="mode === 'hotel'">
                                    <p class="text-body mt-4 mb-4 font-weight-bold">Hotel buscado</p>
                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-map-marker</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="text-body-2 font-weight-medium">{{ name }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ address }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn icon @click.stop="focusMainMarker">
                                                    <v-icon>mdi-image-filter-center-focus</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </template>

                                <template v-if="mode === 'address'">
                                    <p class="text-body mt-4 mb-4 font-weight-bold">Resultados de la búsqueda</p>
                                    <v-list>
                                        <v-list-item>
                                            <v-list-item-icon>
                                                <v-icon>mdi-map-marker</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="text-body-2 font-weight-medium">{{ name }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ address }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn icon @click.stop="focusMainMarker">
                                                    <v-icon>mdi-image-filter-center-focus</v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </template>

                                <p v-if="meetingPoints.length > 0" class="text-body mt-4 mb-0 font-weight-bold">Puntos cercanos</p>
                                <v-list>
                                    <v-list-item v-for="result in meetingPoints" :key="result.id" @click="selectMeetingPoint(result)">
                                        <v-list-item-icon>
                                            <v-icon>mdi-map-marker</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="text-body-2 font-weight-medium">{{ result.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ result.distanceInMetersFormatted }} ({{ result.distanceInSecondsFormatted }})</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn icon @click.stop="focusMeetingPoint(result)">
                                                <v-icon>mdi-image-filter-center-focus</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </perfect-scrollbar>
                    </v-col>
                    <v-col cols="9">
                        <gmap-map :center="center" :zoom="zoom" class="map-container" ref="mapRef">
                            <gmap-marker :position="mainMarkerPosition" v-if="mainMarkerPosition.lat !== 0"></gmap-marker>

                            <gmap-marker
                                v-for="meetingPoint in meetingPoints"
                                :key="meetingPoint.id"
                                :position="{ lat: meetingPoint.latitude, lng: meetingPoint.longitude }"
                                :title="meetingPoint.name"
                                x-icon-blue="https://www.google.com.au/maps/vt/icon/name=assets/icons/spotlight/spotlight_pin_v2_shadow-1-small.png,assets/icons/spotlight/spotlight_pin_v2-1-small.png,assets/icons/spotlight/spotlight_pin_v2_dot-1-small.png,assets/icons/spotlight/spotlight_pin_v2_accent-1-small.png&highlight=00000000,1976D2,0D47A1,00000000&color=ff000000?scale=1"
                                x-icon-yellow="https://www.google.com.au/maps/vt/icon/name=assets/icons/spotlight/spotlight_pin_v2_shadow-1-small.png,assets/icons/spotlight/spotlight_pin_v2-1-small.png,assets/icons/spotlight/spotlight_pin_v2_dot-1-small.png,assets/icons/spotlight/spotlight_pin_v2_accent-1-small.png&highlight=00000000,ffa000,ff6f00,00000000&color=ff000000?scale=1"
                                icon="https://www.google.com.au/maps/vt/icon/name=assets/icons/spotlight/spotlight_pin_v2_shadow-1-small.png,assets/icons/spotlight/spotlight_pin_v2-1-small.png,assets/icons/spotlight/spotlight_pin_v2_dot-1-small.png,assets/icons/spotlight/spotlight_pin_v2_accent-1-small.png&highlight=00000000,7CB342,33691E,00000000&color=ff000000?scale=1"
                            ></gmap-marker>
                        </gmap-map>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="scss">
.ps {
    height: calc(100vh - 64px);
}
.map-container {
    width: 100%;
    height: calc(100vh - 64px);
}
</style>

<script lang="ts">
import { EventBus } from "@/components/EventBus";
import { GetNearestMeetingPointsResponse } from "@/services/ClientInterfaces";
import { DataClient, GetMeetingPointInMapRequest, GetMeetingPointInMapResponse } from "@/services/DataClient";
import { Component, Vue } from "vue-property-decorator";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { VBtn, VCard, VDialog } from "vuetify/lib";

@Component
export default class extends Vue {
    dialog = false;

    mode = "";
    productId = "";
    searchText = "";
    searching = false;

    // resolved
    name = "";
    address = "";

    meetingPoints: Array<{
        id: string;
        name: string;
        longitude: number;
        latitude: number;
        distanceInMeters: number;
        distanceInSeconds: number;
        distanceInMetersFormatted: string;
        distanceInSecondsFormatted: string;
    }> = [];

    zoom = 17;

    center = {
        lat: 0,
        lng: 0,
    };

    mainMarkerPosition = {
        lat: 0,
        lng: 0,
    };

    mounted() {
        EventBus.$on(DataClient.MeetingPoints.OpenMapEvent, this.handleOpenEvent);

        this.reset();
    }

    beforeDestroy() {
        EventBus.$off(DataClient.MeetingPoints.OpenMapEvent, this.handleOpenEvent);
    }

    reset() {
        this.dialog = false;

        this.mode = "";
        this.productId = "";
        this.searchText = "";
        this.searching = false;
        this.name = "";
        this.address = "";
        this.meetingPoints = [];
        this.zoom = 17;
        this.mainMarkerPosition = {
            lat: 0,
            lng: 0,
        };
    }

    async handleOpenEvent(request: GetMeetingPointInMapRequest) {
        let r: GetNearestMeetingPointsResponse | undefined = undefined;

        this.mode = request.mode;
        this.productId = request.productId || "";
        this.searching = true;

        if (request.mode === "hotel") {
            r = await DataClient.MeetingPoints.getNearest({
                hotelId: request.hotelId,
                productId: this.productId,
                maximumResultCount: 9999,
            });

            if (r && r.resolved) {
                this.name = r.resolved.name;
                this.address = r.resolved.address;
                this.meetingPoints = r.meetingPoints;

                this.center = {
                    lat: r.resolved.latitude,
                    lng: r.resolved.longitude,
                };

                this.mainMarkerPosition = {
                    lat: r.resolved.latitude,
                    lng: r.resolved.longitude,
                };
            }
        } else if (request.mode === "address") {
            this.searchAddress(request.address);
        }

        this.searching = false;
        this.dialog = true;

        // this.focus("searchTextField");
    }

    accept(data: GetMeetingPointInMapResponse) {
        DataClient.MeetingPoints.getInMap(data, true);
        this.reset();
    }

    cancel() {
        DataClient.MeetingPoints.getInMap(undefined, true);
        this.reset();
    }

    selectMeetingPoint(meetingPoint: this["meetingPoints"][0]) {
        this.accept({
            id: meetingPoint.id,
            name: meetingPoint.name,
            distanceInMeters: meetingPoint.distanceInMeters || 0,
        });
    }

    focusMeetingPoint(meetingPoint: this["meetingPoints"][0]) {
        this.center = {
            lat: 0,
            lng: 0,
        };
        this.$nextTick(() => {
            this.center = {
                lat: meetingPoint.latitude,
                lng: meetingPoint.longitude,
            };
            this.zoom = 17;
        });
    }

    focusMainMarker() {
        this.center = {
            lat: 0,
            lng: 0,
        };
        this.$nextTick(() => {
            this.center = {
                lat: this.mainMarkerPosition.lat,
                lng: this.mainMarkerPosition.lng,
            };
            this.zoom = 17;
        });
    }

    async searchAddress(address: string) {
        this.mode = "address";
        this.searching = true;

        const r = await DataClient.MeetingPoints.getNearest({
            name: address + ", Mallorca, España",
            productId: this.productId,
            maximumResultCount: 9999,
        });

        this.name = r.resolved.name;
        this.address = r.resolved.address;
        this.meetingPoints = r.meetingPoints;

        this.center = {
            lat: r.resolved.latitude,
            lng: r.resolved.longitude,
        };

        this.mainMarkerPosition = {
            lat: r.resolved.latitude,
            lng: r.resolved.longitude,
        };

        this.searchText = "";
        this.searching = false;
    }
}
</script>
